import moment from "moment";

export const toHour = (dateUTC: string) => moment(dateUTC).locale('fr').format('LTS');

export const toDate = (dateUTC: string, format = 'LL') => moment(dateUTC).locale('fr').format(format);

export const toDatePicker = (dateUTC: moment.Moment) => moment(dateUTC).format('YYYY-MM-DD');

export const timespanToString = (duration: string, format: string = 'mm:ss') => {
  let durationToConvert = duration;
  if (duration.charAt(0) === '-') {
    durationToConvert = durationToConvert.substr(1);
  }
  return moment.utc(moment.duration(durationToConvert).asMilliseconds()).format(format);
};

export const timespanToTotalHour = (duration: string | undefined) => {
  if (duration === undefined) { return '0'; }

  let durationToConvert = duration;
  if (duration.charAt(0) === '-') {
    durationToConvert = durationToConvert.substr(1);
  }
  return Math.round(moment.duration(durationToConvert).asHours()).toString();
};
